/**
 * OCR识别服务
 * 职责：封装OCR识别相关的API请求
 *
 * 统一调用规范：
 * - 所有接口通过 publish 后端代理调用，由后端转发到 shared 服务
 * - API 路径：/api/pubs/v1/ocr/*
 */
import api from './api';

const ocrService = {
  /**
   * 识别身份证信息
   * 代理路径：/api/pubs/v1/ocr/id-card -> /api/shrd/v1/verification/ocr/id-card
   *
   * @param {string} imageBase64 - Base64编码的图片数据
   * @param {string} side - 身份证面：front-正面，back-反面
   * @returns {Promise} 识别结果
   */
  recognizeIdCard: (imageBase64, side = 'front') => {
    return api.post('/api/pubs/v1/ocr/id-card', {
      imageBase64,
      side,
    });
  },

  /**
   * 识别营业执照信息
   * 代理路径：/api/pubs/v1/ocr/business-license -> /api/shrd/v1/verification/ocr/business-license
   *
   * @param {string} imageBase64 - Base64编码的图片数据
   * @returns {Promise} 识别结果
   */
  recognizeBusinessLicense: (imageBase64) => {
    return api.post('/api/pubs/v1/ocr/business-license', {
      imageBase64,
    });
  },
};

export const {
  recognizeIdCard,
  recognizeBusinessLicense,
} = ocrService;

export default ocrService;
